// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"112":"27f23ff3","406":"664128ff","663":"7b7be423","858":"09d807ee"}[chunkId] + ".css";
};